
import { encodeCrosswordClue } from "@utils";

export default {
	name: "CrosswordClueEntry",
	props: {
		clue: {
			type: String,
			required: true,
		},
		answer: {
			type: String,
			required: false,
			default: null,
		},
		visible: {
			type: Boolean,
			required: false,
			default: true,
		},
	},
	data() {
		return {
			showAnswer: false,
		};
	},
	computed: {
		clueUrl() {
			return `/crosswords/clues/${encodeCrosswordClue(this.clue)}/`;
		},
	},
	methods: {
		revealAnswer() {
			if (this.showAnswer) {
				return;
			}

			this.showAnswer = true;

			// Emit event to parent for GA tracking
			this.$emit("answer-revealed");
		},
	},
};
